import React, { createContext, useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import Service from '../apis/service';
import GetToken from '../apis/GetToken';

export const AuthContext = createContext();

export const AuthContextProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const cookies = new Cookies();
    const accessToken = cookies.get('access_token');
    if (accessToken) setIsLoggedIn(true);
  }, []);

  Service.setupInterceptors(
    (config) =>
      new Promise((resolve) => {
        const cookies = new Cookies();
        const accessToken = cookies.get('access_token');
        const updatedConfig = { ...config };
        if (accessToken) {
          GetToken().then(() => {
            const updatedAccessToken = cookies.get('access_token');
            updatedConfig.headers.Authorization = `Bearer ${updatedAccessToken}`;
            resolve(updatedConfig);
          });
        }
      }),
  );
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn }}>{props.children}</AuthContext.Provider>;
};
